import { ensureValidLocale } from "./localePreference";

/** Sync <html lang> and <body lang> with the active locale (SPA + footer switches). */
export function setDocumentLocale(locale) {
  const lang = ensureValidLocale(locale);
  document.documentElement.lang = lang;
  if (document.body) {
    document.body.lang = lang;
  }
}
